export default __webpack_public_path__ + "static/media/attraction2.b22ddd41.jpg";